import { OtherPageComponent } from './other_page/other_pages.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { HomeSegurosComponent } from './seguros/home-seguros/home-seguros.component';
import { SingleSegurosComponent } from './seguros/single-seguros/single-seguros.component';
import { HomeSucursalesComponent } from './sucursales/home-sucursales/home-sucursales.component';
import { LoaderComponent } from './seguros/home-seguros/cuerpo/loader/loader.component';
import { ThankyoupageComponent } from './seguros/home-seguros/cuerpo/thankyoupage/thankyoupage.component';
import { RejectedComponent } from './seguros/home-seguros/cuerpo/rejected/rejected.component';

export const WEBS_ROUTES: Routes = [
    // {
    //     path: '',
    //     redirectTo: 'home',
    //     pathMatch: 'full'
    // },
    {
        path: 'home',
        component: HomeSegurosComponent,
        data: {
            title: 'HOME'
        }
    },
    {
        path: 'redireccion',
        component: LoaderComponent,
        data: {
            title: 'REDIRECCION'
        }
    },
    {
        path: 'thankyoupage',
        component: ThankyoupageComponent,
        data: {
            title: 'THANKYOUPAGE'
        }
    },
    {
        path: 'rejected',
        component: RejectedComponent,
        data: {
            title: 'REJECTED'
        }
    },
    // {
    //     path: 'paginas',
    //     loadChildren: './pages/pages.module#PagesModule'
    // },
    // {
    //     path: 'hoteles',
    //     component: HomeComponent,
    //     data: {
    //         title: 'HOTELES'
    //     }
    // },
    // {
    //     path: 'vuelos',
    //     component: HomeComponent,
    //     data: {
    //         title: 'vuelos'
    //     }
    // },
    // {
    //     path: 'tours',
    //     component: HomeComponent,
    //     data: {
    //         title: 'TOURS'
    //     }
    // },
    // {
    //     path: 'vuelosandhotel',
    //     component: HomeComponent,
    //     data: {
    //         title: 'VUELO + HOTEL'
    //     }
    // },
    // { path: 'seguros', component: HomeComponent },
    // { path: 'seguros/:slug', component: SingleSegurosComponent },
    // { path: 'pt_prodensure/:slug', redirectTo: 'seguros/:slug' },
    // { path: 'sucursales', component: HomeSucursalesComponent },
    {
        path: '**',
        component: OtherPageComponent
    }
];

@NgModule({
    imports: [RouterModule.forChild(WEBS_ROUTES)],
    exports: [RouterModule]
})
export class WebRoutingModule { }
